import React, {useEffect, useState} from "react"
import { Div, Text, Container, Col, Row, Tag, Icon } from "atomize";
import styled from "styled-components";
import Header from "../Components/Molecules/Header";
import {apiGet} from "../Api";
import Heading from "../Components/Atoms/Heading";
import theme from "../Theme/Theme";
import ActivityHeader from './../Components/Molecules/ActivityHeader';
import AnchorLink from "../Components/Atoms/AnchorLink";
import {PrimaryButton, SecondaryButton} from "../Components/Atoms/Button";
import VideoCard from "../Components/Molecules/VideoCard";
import GoogleDocsViewer from "react-google-docs-viewer";
import {baseUrl} from "../Constants/constants";
import { connect } from "react-redux";
import {bindActionCreators} from "redux";
import {addActivity, removeActivity} from "../redux/actions";
import {withRouter} from 'react-router-dom';
import Image from "./../Components/Atoms/Image";
import Skeleton from "react-loading-skeleton";
import createZipDownload from "../utils/createZipDownload";
import SEO from "../Components/Atoms/SEO";
import ReactGA from "react-ga";


const Subtitle = styled.p`
  font-family: Inter;
  font-weight: 700;
  font-size: 14px;
  color: ${theme.colors.grayDark};
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 2rem;
`;

const AnchorWrapper = styled(Div)`
  display: flex;
  flex-wrap: wrap;
  > div {
    margin: .25rem 1.5rem .25rem 0;
  }
`;

const Border = styled(Div)`
  // max-width: 500px;
  border: 1px solid #C9CED6;
  border-radius: 4px;
  padding: 2rem 1rem 1rem 1rem;
  margin-top: 1rem;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  
  
  @media (max-width: 550px) {
    a, button {
      display: flex;
      width: 100%;
    }
  }
  
  @media (max-width: 550px) {
    .primary-wrapper {
      display: flex;
      width: 100%;
    }
  }
  
  a, button {
    margin: 0;
    margin-bottom: 1rem;
  }
`;

const Body = styled(Div)`
  font-family: Inter;
  font-size: 14px;
  color: ${theme.colors.grayDark};
  letter-spacing: 0;
  line-height: 24px;
  margin-bottom: 1rem;
`;

const VideoWrapper = styled(Div)`
  // max-width: 450px;
  margin-top: 1rem;
  width: 100%;
  
  img {
    width: 100%;
  }
`;

const FlexCol = styled(Col)`
  display: flex;
`;

const MaterialWrapper = styled(Div)`
  margin-bottom: 6rem;
`;

function ActivityPure(props) {
  ReactGA.pageview(window.location.pathname + window.location.search);

  const activity = props.match.params.activity;
  const [data, setData] = useState(null);
  const [heroImgUrl, setHeroImgUrl] = useState(null);
  const [video, setVideo] = useState(null);
  const [media, setMedia] = useState(null);
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    async function fetchData() {
      const result = await apiGet(`/node/activity?filter[title]=${activity}&include=field_banner_image,field_experience_layer,field_course_phase,field_activity_type,field_materials,field_video&jsonapi_include=1`);
      setData(result.data.data[0]);
      result.data.data[0].field_banner_image.uri && setHeroImgUrl(result.data.data[0].field_banner_image.uri.url);

      if (result.data.data[0].field_video.field_video_source) {
        setVideo(result.data.data[0].field_video);
        let id = result.data.data[0].field_video.field_video_source.id;
        const videoMedia = await apiGet(`/media/remote_video/${id}?include=thumbnail&jsonapi_include=1`);
        setMedia(videoMedia.data.data);
      }
    }
    fetchData();
  }, [props.match.params.activity]);

  return (
    <Div>
      <SEO
        title={ data && data.title ? data.title : "Stories | Engineering for Humanity | Olin College of Engineering"}
        description={data && data.field_description ? data.field_description : null}
      />
      <Header
        pageTitle={ null }
        heroImgUrl={ heroImgUrl }
        height={125}
        link={{
          url: '/activities',
          text: 'Back to all activities'
        }}
      />
      <Container>
        {
          data &&
          <ActivityHeader
            title={data.title}
            type={data.field_activity_type.name}
            color={data.field_experience_layer.field_color ? data.field_experience_layer.field_color.color : theme.colors.primary}
          />
        }
        {
          data &&
          <Row>
            <Col
              size={{ xs: '12', sm: '12', md: '8', lg: '7' }}
            >
              <Border>
                {
                  props.collectorActivities.filter( a => a.id === data.id ).length > 0 ?
                  <PrimaryButton
                    icon={'Minus'}
                    type={'button'}
                    action={() => props.removeActivity(data)}
                    text={'Remove from my collection'}
                  />
                  :
                  <PrimaryButton
                    icon={'Plus'}
                    type={'button'}
                    action={() => props.addActivity(data)}
                    text={'Add to my collection'}
                  />
                }
                <SecondaryButton
                  icon={ loading? 'Loading' : 'Download'}
                  type={'button'}
                  action={() => {
                    if (!loading) {
                      setLoading(true);
                      createZipDownload([data])
                        .then( res => {
                          if (res) {
                            setLoading(false)
                          }
                        })
                    }
                  }}
                  text={'Direct download'}
                />
              </Border>
              <div
                style={{ marginTop: '2rem'}}
              >
                {
                  data.field_duration &&
                  <Tag
                    m={{ r: "1rem", b: "1rem" }}
                    prefix={<Icon name="Timestamp" size="12px" m={{ r: "0.25rem" }} />}
                  >
                    {data.field_duration} minutes {data.field_recurring ? "- recurring" : ""}
                  </Tag>
                }
                {data.body &&
                  <Body dangerouslySetInnerHTML={{__html: data.body.value}}/>
                }
              </div>
            </Col>
            <FlexCol
              size={{ xs: '12', sm: '12', md: '4', lg: '5' }}
              justify="center"
            >
              <VideoWrapper>
                {
                  video && media &&
                  <VideoCard
                    mediaObj={media}
                    video={video}
                    showTitle={false}
                  />
                }
                {
                  !video && data.field_image.meta &&
                  <Image
                    image={data.field_image}
                  />
                }
                {
                  !video && !data.field_image.meta && heroImgUrl &&
                    <Div
                      bgImg={ baseUrl + heroImgUrl } bgSize="cover" bgPos="center"
                      style={{ width: '100%', height: '100%'}}
                    />
                }
                {
                  !video && !data.field_image.meta && !heroImgUrl &&
                  <Skeleton height={'5rem'}/>
                }
              </VideoWrapper>
            </FlexCol>
            <Col
              size={'12'}
            >
              <Subtitle>
                Included materials
              </Subtitle>
              <AnchorWrapper>
                {
                 data.field_materials.length > 0 && data.field_materials.map( material => {
                    return (
                      <AnchorLink
                        key={material.id}
                        id={material.id}
                        title={material.filename}
                        path={ activity}
                        history={props.history}
                      />
                    )
                  })
                }
              </AnchorWrapper>
            </Col>
          </Row>
        }
        {
         data && data.field_materials.length > 0 && data.field_materials.map( material => {
           let url = baseUrl + material.uri.url;
            return (
              <MaterialWrapper
                key={material.id}
              >
                <Heading
                  title={material.filename}
                  id={material.id}
                  formatHeading={true}
                />
                {/*<FileViewer*/}
                  {/*fileType={'png'}*/}
                  {/*filePath={'https://cors-anywhere.herokuapp.com/' + url}*/}
                {/*/>*/}
                <GoogleDocsViewer
                  width="100%"
                  height="780px"
                  fileUrl={url}
                />
              </MaterialWrapper>
            )
          })
        }
      </Container>
    </Div>
  )
}

class Activity extends React.Component {
  render() {
    return (
      <ActivityPure
        {...this.props}
      />
    )
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      addActivity: addActivity,
      removeActivity: removeActivity
    },
    dispatch
  );
};

const mapStateToProps = state => {
  if (state === undefined) return {};
  return {
    collectorActivities: state.collectorActivities.collectorActivities
  };
};

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(Activity));
